var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ClientLedger',{attrs:{"title":"Client Account Ledger","url":"contact/report/ledger-account"},on:{"componentLedgerBack":_vm.componentParent}})
}
var staticRenderFns = []

export { render, staticRenderFns }